import { StaticModal } from '@nexelem/modals';
import { Button, IconButton, Popover } from '@nexelem/components';
import { useFormContext } from 'react-hook-form';
import { useCustomTranslation } from '../../../../../../../../hooks/useCustomTranslation';
import { SimulationFormData } from '../..';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft, faCircleQuestion } from '@fortawesome/pro-light-svg-icons';
import { ReactNode } from 'react';

type SimulationEditHeaderProps = {
  simulationFilters?: ReactNode;
};

export const SimulationEditHeader = ({ simulationFilters }: SimulationEditHeaderProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const {
    reset,
    formState: { dirtyFields },
  } = useFormContext<SimulationFormData>();

  const hasChanges = Object.keys(dirtyFields).length > 0;

  return (
    <StaticModal.Header
      withCloseButton
      Actions={() => (
        <div>
          {hasChanges && (
            <Button
              className="mr-4"
              StartIcon={<FontAwesomeIcon icon={faRotateLeft} />}
              variant="outlined"
              onClick={() => reset()}
            >
              {tWrapper('headerReset')}
            </Button>
          )}
        </div>
      )}
    >
      <div className="flex items-center gap-1">
        <span className="text-t24-sb">{tWrapper('headerTitle')}</span>
        <Popover.Root>
          <Popover.Trigger>
            <IconButton Icon={<FontAwesomeIcon icon={faCircleQuestion} />} />
          </Popover.Trigger>
          <Popover.Content>
            <div>
              {tWrapper('headerTooltipDescription')}
              <ul className="list-disc pl-4">
                <li>{tWrapper('headerTooltipChangeQuantities')}</li>
                <li>{tWrapper('headerTooltipChangeTechnology')}</li>
              </ul>
            </div>
          </Popover.Content>
        </Popover.Root>
        {simulationFilters}
      </div>
    </StaticModal.Header>
  );
};
